import React from "react";
//#region types
import { WeekDateSummaryProps } from "models/propTypes/timeReportingPropTypes";
import { DateConstants } from "utils/constants";
import { TranslationKeys } from "translations";
import { StyleEnums } from "models/enums";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { StyledButton } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const WeekDateRange: React.FC<WeekDateSummaryProps> = (props) => {
  const { start, end, onShowMonth } = props;
  return (
    <Grid container direction="column" className={cssExports.entityTitleContainer} alignItems="center">
      <Grid item className={cssExports.statusLabelContainer}>
        <div className={cssExports.statusLabel}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.ThisWeek)}
        </div>
      </Grid>

      <Grid item>
        {start.getMonth() !== end.getMonth()
          ? `${start.getDate()} ${LocalizationHelperInstance.getFormattedDate(
              props.start,
              DateConstants.MonthShortConfig
            )} - ${end.getDate()} ${LocalizationHelperInstance.getFormattedDate(
              props.end,
              DateConstants.MonthShortConfig
            )}`
          : `${new Date(props.start).getDate()} - ${new Date(
              props.end
            ).getDate()} ${LocalizationHelperInstance.getFormattedDate(
              new Date(props.end),
              DateConstants.MonthLongConfig
            )}`}
      </Grid>
      <Grid item className={cssExports.bottomText}>
        <StyledButton displayType={StyleEnums.DisplayType.None} onClick={onShowMonth}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.ShowAll, "", {
            monthLong: LocalizationHelperInstance.getFormattedDate(start, DateConstants.MonthLongConfig),
          })}
        </StyledButton>
      </Grid>
    </Grid>
  );
};

export default WeekDateRange;
